/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { getTKT1ImageAlbums, createTKT1ImageAlbum, updateTKT1ImageAlbum, deleteTKT1ImageAlbum, getTKT1RegisteredEtsyShops } from '../actions';
import ScrollToTop from "react-scroll-to-top";
import Pagination from "../components/Pagination";
import { CONFIGS } from "../configs";
import { getTranslate, LANGUAGE_KEYS } from "../utils";
import queryString from 'query-string';
import {
  Badge,
  Button,
  Card,
  Form,
  Table,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup,
  Modal
} from "react-bootstrap";
import { FaTimes, FaEye, FaEdit, FaTrash, FaCopy, FaUpload, FaImage, FaStickyNote, FaList, FaTh, FaWindowMaximize, FaThLarge, FaThList, FaSortAmountDown, FaSortAmountUp, FaInfo, FaExternalLinkAlt, FaExpand, FaPencilAlt } from 'react-icons/fa';
import Select from 'react-select';
import ImageUploadModal from '../components/ImageUploadModal/ImageUploadModal';
import IframeModal from '../components/IframeModal/IframeModal';
import { toast } from 'react-toastify';

class TKT1ImageAlbum extends Component {
  initQuery = {
    currentPage: 1,
    itemsPerPage: 100,
    sortBy: 'created_at',
    sortOrder: -1,
    search: '',
    type: '',
    status: '',
    registered_shop_mid: '',
    date_filter: ''
  }

  initShowColumns = {
    list: {
      mid: true,
      name: true,
      description: true,
      cover_url: true,
      type: true,
      status: true,
      username: true,
      tags: true,
      note: true,
      listing_id: true,
      shop: true,
      created_at: true,
      updated_at: true
    },
    grid: {
      mid: true,
      name: true,
      description: true,
      cover_url: true,
      type: true,
      status: true,
      username: true,
      tags: true,
      note: true,
      listing_id: true,
      shop: true,
      created_at: true,
      updated_at: true
    }
  }

  initColumnWidths = {
    stt: 60,
    mid: 100,
    cover_url: 80,
    name: 200,
    description: 250,
    type: 100,
    status: 120,
    username: 150,
    tags: 200,
    note: 200,
    listing_id: 120,
    shop: 150,
    created_at: 150,
    updated_at: 150,
    actions: 100
  }

  constructor() {
    super();
    
    // Add request tracking to prevent race conditions
    this.currentRequestId = 0;
    
    this.state = {
      query: this.initQuery,
      showColumns: this.initShowColumns,
      columnWidths: this.initColumnWidths,
      loading: false,
      showConfigModal: false,
      showCreateModal: false,
      showEditModal: false,
      showViewModal: false,
      showImageUploadModal: false,
      showNoteModal: false,
      showIframeModal: false,
      selectedAlbum: null,
      selectedNoteData: null,
      isEditMode: false,
      uploadingImages: false,
      uploadedImages: [],
      uploadProgress: 0, // For upload progress
      isResizing: false,
      resizingColumn: null,
      resizeStartX: null,
      resizeStartWidth: null,
      viewMode: 'grid', // 'list' or 'grid'
      configMode: 'grid', // 'list' or 'grid' - for config modal
      gridSize: 6, // 4 or 6 items per row in grid mode
      createFormData: {
        mid: '',
        name: '',
        description: '',
        cover_url: '',
        type: 'OTHER_PUBLIC', // Will be overridden in componentDidMount
        status: 'ACTIVE',
        note: '',
        username: '',
        tags: [],
        tagsString: '',
        original_listing_id: '',
        posted_listing_id: '',
        registered_shop_mid: ''
      },
      editFormData: {
        mid: '',
        name: '',
        description: '',
        cover_url: '',
        type: 'OTHER_PUBLIC',
        status: 'ACTIVE',
        note: '',
        username: '',
        tags: [],
        tagsString: '',
        original_listing_id: '',
        posted_listing_id: '',
        registered_shop_mid: ''
      }
    };
  }

  componentDidMount() {
    const routeType = this.getRouteType();
    
    
    // For non-'all' routes, we'll preserve localStorage but ensure correct type in prepareApiQuery
    // The prepareApiQuery method will force the correct type regardless of what's in localStorage
    
    // Clear any conflicting localStorage data for different routes
    this.clearConflictingLocalStorage(routeType);
    
    const titleMap = {
      'all': 'TKT1 Image Album - All',
      'LISTING': 'TKT1 Image Album - Listing',
      'AVATAR': 'TKT1 Image Album - Avatar',
      'C3D': 'TKT1 Image Album - C3D',
      'SCAN_PERSON': 'TKT1 Image Album - Scan Person',
      'BACKGROUND': 'TKT1 Image Album - Background',
      'DECORATING': 'TKT1 Image Album - Decorating',
      'OTHER_PUBLIC': 'TKT1 Image Album - Other Public',
      'OTHER_PRIVATE': 'TKT1 Image Album - Other Private',
      'ONM_SHAPE': 'TKT1 Image Album - ONM Shape',
      'ONM_OBJECT': 'TKT1 Image Album - ONM Object',
      'ONM_IMAGE': 'TKT1 Image Album - ONM Image'
    };
    document.title = titleMap[routeType] || 'TKT1 Image Album';
    const queryStringFromUrl = window.location.search;
    const urlParams = new URLSearchParams(queryStringFromUrl);
    
    // Check if URL has any query parameters
    const hasUrlParams = queryStringFromUrl && queryStringFromUrl.length > 1;
    
    // Load view mode and grid size from localStorage for this specific route
    const viewModeKey = `tkt1_image_album_view_mode_${routeType}`;
    const savedViewMode = localStorage.getItem(viewModeKey) || 'grid';
    const gridSizeKey = `tkt1_image_album_grid_size_${routeType}`;
    const savedGridSize = parseInt(localStorage.getItem(gridSizeKey)) || 6;
    
    if (hasUrlParams) {
      // URL has query parameters - override localStorage
      const queryObject = queryString.parse(queryStringFromUrl);
      
      // Parse numeric values
      ['itemsPerPage', 'currentPage'].map(key => {
        if (queryObject[key]) {
          queryObject[key] = parseInt(queryObject[key])
        }
      })
      if (queryObject.sortOrder) {
        queryObject.sortOrder = parseInt(queryObject.sortOrder);
      }
      
      // Load showColumns separately from view config
      const viewConfig = JSON.parse(localStorage.getItem('TKT1ImageAlbum_ViewConfig'));
      const columnWidths = JSON.parse(localStorage.getItem('TKT1ImageAlbum_ColumnWidths'));
      
      const restoredQuery = {
        ...this.initQuery,
        ...queryObject
      };

      // Override type based on route if not 'all'
      if (routeType !== 'all') {
        restoredQuery.type = routeType;
      }

      // Set default type based on current route
      const defaultType = routeType !== 'all' ? routeType : 'OTHER_PUBLIC';
      
      this.setState({
        query: restoredQuery,
        createFormData: {
          ...this.state.createFormData,
          type: (queryObject.type ? String(queryObject.type).toUpperCase() : defaultType)
        },
        showColumns: {
          list: {
            ...this.initShowColumns.list,
            ...(viewConfig?.list || {})
          },
          grid: {
            ...this.initShowColumns.grid,
            ...(viewConfig?.grid || {})
          }
        },
        columnWidths: {
          ...this.initColumnWidths,
          ...(columnWidths || {})
        },
        viewMode: savedViewMode,
        gridSize: savedGridSize
      }, () => {
        // Don't call API here - will be called at the end of componentDidMount
        console.log('TKT1ImageAlbum - componentDidMount: URL params case - setting state');
      })
    } else {
      // No URL params - use localStorage with route-specific key
      var query = JSON.parse(localStorage.getItem(`tkt1_image_album_query_${routeType}`));
      var viewConfig = JSON.parse(localStorage.getItem('TKT1ImageAlbum_ViewConfig'));
      var columnWidths = JSON.parse(localStorage.getItem('TKT1ImageAlbum_ColumnWidths'));
      
      // Keep the stored query but we'll override the type in the restored query
      // This preserves user's search terms, filters, etc.
      
      if (query) {
        const restored = {
          ...this.initQuery,
          ...query
        };
        restored.itemsPerPage = parseInt(restored.itemsPerPage || this.initQuery.itemsPerPage);
        restored.currentPage = parseInt(restored.currentPage || this.initQuery.currentPage);
        restored.sortOrder = parseInt(restored.sortOrder || this.initQuery.sortOrder);

        // ALWAYS override type based on route - this is critical for correct data loading
        if (routeType !== 'all') {
          restored.type = routeType;
        }

        // Set default type based on current route
        const defaultType = routeType !== 'all' ? routeType : 'OTHER_PUBLIC';
        
        this.setState({
          query: restored,
          createFormData: {
            ...this.state.createFormData,
            type: defaultType
          },
          showColumns: {
            list: {
              ...this.initShowColumns.list,
              ...(viewConfig?.list || {})
            },
            grid: {
              ...this.initShowColumns.grid,
              ...(viewConfig?.grid || {})
            }
          },
          columnWidths: {
            ...this.initColumnWidths,
            ...(columnWidths || {})
          },
          viewMode: savedViewMode,
          gridSize: savedGridSize
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1ImageAlbums(apiQuery);
        })
      } else {
        // Create initial query with route type override
        const initialQuery = { ...this.initQuery };
        if (routeType !== 'all') {
          initialQuery.type = routeType;
        }

        // Set default type based on current route
        const defaultType = routeType !== 'all' ? routeType : 'OTHER_PUBLIC';
        
        this.setState({
          query: initialQuery,
          createFormData: {
            ...this.state.createFormData,
            type: defaultType
          },
          showColumns: {
            list: {
              ...this.initShowColumns.list,
              ...(viewConfig?.list || {})
            },
            grid: {
              ...this.initShowColumns.grid,
              ...(viewConfig?.grid || {})
            }
          },
          columnWidths: {
            ...this.initColumnWidths,
            ...(columnWidths || {})
          },
          viewMode: savedViewMode,
          gridSize: savedGridSize
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1ImageAlbums(apiQuery);
        })
      }
    }
    
    // Add mouse event listeners for column resizing
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
    
    // Load registered shops data
    this.loadRegisteredShops();
  }

  componentDidUpdate(prevProps) {
    // Hide loading when albums data changes (API call completed)
    if (prevProps.albums !== this.props.albums || prevProps.totalCount !== this.props.totalCount) {
      this.setState({ loading: false });
      this.forceUpdate();
    }
    
    // Check if the route has changed
    const currentRouteType = this.getRouteType();
    const prevPath = prevProps.location?.pathname;
    const currentPath = window.location.pathname;
    
    if (prevPath && prevPath !== currentPath) {
      
      // Check for localStorage conflicts but preserve user data
      this.clearConflictingLocalStorage(currentRouteType);
      
      // Force reload with correct route type but preserve user's search/filter settings
      const newQuery = { ...this.state.query }; // Keep current query state
      if (currentRouteType !== 'all') {
        newQuery.type = currentRouteType; // Only override the type
      }
      
      this.setState({ query: newQuery }, () => {
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1ImageAlbums(apiQuery);
      });
    }
  }

  componentWillUnmount() {
    // Remove mouse event listeners
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
    
    // Clear any pending timeouts
    if (this.shopChangeTimeout) {
      clearTimeout(this.shopChangeTimeout);
    }
    
    // Mark that component is being unmounted (for remount detection)
    sessionStorage.setItem('tkt1_image_album_was_mounted', 'true');
  }

  getRouteType = () => {
    const path = window.location.pathname;
    
    // Check ORNAMENT routes first
    if (path === '/admin/rnd/ornament/shape' || path.endsWith('/rnd/ornament/shape')) return 'ONM_SHAPE';
    if (path === '/admin/rnd/ornament/object' || path.endsWith('/rnd/ornament/object')) return 'ONM_OBJECT';
    if (path === '/admin/rnd/ornament/image' || path.endsWith('/rnd/ornament/image')) return 'ONM_IMAGE';
    
    // Use exact matching to avoid conflicts
    if (path === '/admin/tkt1-media/album/all' || path.endsWith('/tkt1-media/album/all')) return 'all';
    if (path === '/admin/tkt1-media/album/listing' || path.endsWith('/tkt1-media/album/listing')) return 'LISTING';
    if (path === '/admin/tkt1-media/album/avatar' || path.endsWith('/tkt1-media/album/avatar')) return 'AVATAR';
    if (path === '/admin/tkt1-media/album/c3d' || path.endsWith('/tkt1-media/album/c3d')) return 'C3D';
    if (path === '/admin/tkt1-media/album/scan-person' || path.endsWith('/tkt1-media/album/scan-person')) return 'SCAN_PERSON';
    if (path === '/admin/tkt1-media/album/background' || path.endsWith('/tkt1-media/album/background')) return 'BACKGROUND';
    if (path === '/admin/tkt1-media/album/decorating' || path.endsWith('/tkt1-media/album/decorating')) return 'DECORATING';
    if (path === '/admin/tkt1-media/album/other-public' || path.endsWith('/tkt1-media/album/other-public')) return 'OTHER_PUBLIC';
    if (path === '/admin/tkt1-media/album/other-private' || path.endsWith('/tkt1-media/album/other-private')) return 'OTHER_PRIVATE';
    
    // Try to get type from URL query params as fallback
    const urlParams = new URLSearchParams(window.location.search);
    const typeFromQuery = urlParams.get('type');
    if (typeFromQuery) {
      return typeFromQuery.toUpperCase();
    }
    
    return 'all'; // default fallback
  }

  // Helper method to determine which fields should be shown based on route
  shouldShowListingFields = () => {
    const routeType = this.getRouteType();
    return routeType === 'LISTING';
  }

  shouldShowShopField = () => {
    const routeType = this.getRouteType();
    return routeType === 'LISTING' || routeType === 'BACKGROUND' || routeType === 'DECORATING';
  }

  shouldShowShopFilter = () => {
    const routeType = this.getRouteType();
    return routeType === 'LISTING' || routeType === 'BACKGROUND' || routeType === 'DECORATING';
  }

  // Check localStorage data that might conflict with current route
  clearConflictingLocalStorage = (currentRouteType) => {
    // Get the current query from localStorage
    const currentQuery = JSON.parse(localStorage.getItem('tkt1_image_album_query') || '{}');
    
    
    // Preserve localStorage data - user needs their search terms, filters, pagination, etc.
    // Only the type field will be overridden in prepareApiQuery to match the current route
  }

  loadData = () => {
    const apiQuery = this.prepareApiQuery(this.state.query);
    this.props.getTKT1ImageAlbums(apiQuery);
  }


  loadRegisteredShops = async () => {
    try {
      // Load registered shops data for dropdown
      const query = { currentPage: 1, itemsPerPage: 1000, sortBy: 'MID', sortOrder: 1 };
      await this.props.getTKT1RegisteredEtsyShops(query);
    } catch (error) {
      console.error('Error loading registered shops:', error);
    }
  }

  getRegisteredShopOptions = () => {
    return this.props.registeredEtsyShops ? this.props.registeredEtsyShops.map((shop) => ({
      value: shop.MID,
      label: `${shop.MID} - ${shop.trusted_story_info?.etsy_shop_name || shop.shop_id || 'N/A'}`
    })) : [];
  }

  getShopNameFromMid = (shopMid) => {
    if (!shopMid || !this.props.registeredEtsyShops) return shopMid;
    
    const shop = this.props.registeredEtsyShops.find(s => s.MID === shopMid);
    return shop?.trusted_story_info?.etsy_shop_name || shopMid;
  }


  handleChangeSearch = (e) => {
    const value = e.target.value;
    
    this.setState({
      query: { ...this.state.query, search: value }
    })
  }

  handleClearSearch = () => {
    // Show loading immediately
    this.setState({ loading: true });
    
    this.setState({
      query: { ...this.state.query, search: '' }
    }, () => {
      this.handleSearch();
    })
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }

  handleTypeChange = (e) => {
    const newQuery = { ...this.state.query, type: e.target.value };
    console.log('TKT1ImageAlbum - handleTypeChange:', { value: e.target.value, newQuery });
    
    // Show loading immediately
    this.setState({ loading: true });
    
    this.setState({ query: newQuery }, () => {
      const routeType = this.getRouteType();
      localStorage.setItem(`tkt1_image_album_query_${routeType}`, JSON.stringify(newQuery));
      
      // Auto search when dropdown changes
      this.updateUrl(newQuery);
      this.loadData(); // This will add to history
    });
  }

  handleStatusChange = (e) => {
    const newQuery = { ...this.state.query, status: e.target.value };
    console.log('TKT1ImageAlbum - handleStatusChange:', { value: e.target.value, newQuery });
    
    // Show loading immediately
    this.setState({ loading: true });
    
    this.setState({ query: newQuery }, () => {
      const routeType = this.getRouteType();
      localStorage.setItem(`tkt1_image_album_query_${routeType}`, JSON.stringify(newQuery));
      
      // Auto search when dropdown changes
      this.updateUrl(newQuery);
      this.loadData(); // This will add to history
    });
  }

  handleShopChange = (e) => {
    const value = e.target.value;
    const newQuery = { ...this.state.query, registered_shop_mid: value, currentPage: 1 };
    
    // Show loading immediately
    this.setState({ loading: true });
    
    // Clear any existing timeout
    if (this.shopChangeTimeout) {
      clearTimeout(this.shopChangeTimeout);
    }
    
    // Debounce the API call to prevent race conditions
    this.shopChangeTimeout = setTimeout(() => {
      this.setState({ query: newQuery }, () => {
        const routeType = this.getRouteType();
        localStorage.setItem(`tkt1_image_album_query_${routeType}`, JSON.stringify(newQuery));
        
        // Auto search when dropdown changes
        this.updateUrl(newQuery);
        this.loadData(); // This will add to history
      });
    }, 300); // 300ms debounce
  }

  handleDateFilterChange = (e) => {
    const newQuery = { ...this.state.query, date_filter: e.target.value };
    
    // Show loading immediately
    this.setState({ loading: true });
    
    this.setState({ query: newQuery }, () => {
      const routeType = this.getRouteType();
      localStorage.setItem(`tkt1_image_album_query_${routeType}`, JSON.stringify(newQuery));
      
      // Auto search when dropdown changes
      this.updateUrl(newQuery);
      this.loadData(); // This will add to history
    });
  }

  handleSelectSort = (e) => {
    const newQuery = { ...this.state.query, sortBy: e.target.value };
    
    // Show loading immediately
    this.setState({ loading: true });
    
    this.setState({ query: newQuery }, () => {
      const routeType = this.getRouteType();
      localStorage.setItem(`tkt1_image_album_query_${routeType}`, JSON.stringify(newQuery));
      
      // Auto search when dropdown changes
      this.updateUrl(newQuery);
      this.loadData(); // This will add to history
    });
  }

  handleSelectSortOrder = (e) => {
    const newQuery = { ...this.state.query, sortOrder: parseInt(e.target.value) };
    
    // Show loading immediately
    this.setState({ loading: true });
    
    this.setState({ query: newQuery }, () => {
      const routeType = this.getRouteType();
      localStorage.setItem(`tkt1_image_album_query_${routeType}`, JSON.stringify(newQuery));
      
      // Auto search when dropdown changes
      this.updateUrl(newQuery);
      this.loadData(); // This will add to history
    });
  }

  handleColumnToggle = (columnKey) => {
    this.setState(prevState => {
      const currentMode = this.state.configMode; // Use configMode to determine which config to update
      const newShowColumns = {
        ...prevState.showColumns,
        [currentMode]: {
          ...prevState.showColumns[currentMode],
          [columnKey]: !prevState.showColumns[currentMode][columnKey]
        }
      };
      
      // Save view config to localStorage
      localStorage.setItem('TKT1ImageAlbum_ViewConfig', JSON.stringify(newShowColumns));
      
      return { showColumns: newShowColumns };
    })
  }

  handleViewModeToggle = (mode) => {
    const routeType = this.getRouteType();
    this.setState({ viewMode: mode });
    localStorage.setItem(`tkt1_image_album_view_mode_${routeType}`, mode);
  }

  handleGridSizeToggle = (size) => {
    const routeType = this.getRouteType();
    this.setState({ gridSize: size });
    localStorage.setItem(`tkt1_image_album_grid_size_${routeType}`, size.toString());
  }

  // Column resizing handlers
  resetColumnWidths = () => {
    this.setState({ columnWidths: this.initColumnWidths });
    localStorage.removeItem('TKT1ImageAlbum_ColumnWidths');
  }

  handleMouseDown = (e, columnKey) => {
    e.preventDefault();
    e.stopPropagation();
    
    this.setState({
      isResizing: true,
      resizingColumn: columnKey,
      resizeStartX: e.clientX,
      resizeStartWidth: this.state.columnWidths[columnKey]
    });
    
    document.body.classList.add('table-resizing');
  }

  handleMouseMove = (e) => {
    if (!this.state.isResizing || !this.state.resizingColumn) return;
    
    e.preventDefault();
    const deltaX = e.clientX - this.state.resizeStartX;
    const newWidth = Math.max(50, this.state.resizeStartWidth + deltaX);
    const resizingColumn = this.state.resizingColumn;
    
    this.setState(prevState => ({
      columnWidths: {
        ...prevState.columnWidths,
        [resizingColumn]: newWidth
      }
    }));
  }

  handleMouseUp = () => {
    if (this.state.isResizing) {
      this.setState({
        isResizing: false,
        resizingColumn: null,
        resizeStartX: null,
        resizeStartWidth: null
      });
      
      document.body.classList.remove('table-resizing');
      
      // Save column widths to localStorage
      localStorage.setItem('TKT1ImageAlbum_ColumnWidths', JSON.stringify(this.state.columnWidths));
    }
  }

  // Map status to Vietnamese
  mapStatus = (status, album = null) => {
    if (!status) return '-';
    
    switch (status.toUpperCase()) {
      case 'ACTIVE':
        return 'Hoạt động';
      case 'INACTIVE':
        return 'Không hoạt động';
      case 'DRAFT':
        return 'Bản nháp';
      case 'PUBLISHED':
        return 'Đã xuất bản';
      case 'ARCHIVED':
        return 'Đã lưu trữ';
      case 'PENDING':
        return 'Chờ duyệt';
      case 'REJECTED':
        return 'Từ chối';
      default:
        return status;
    }
  }

  // Map type to Vietnamese
  mapType = (type) => {
    if (!type) return '-';
    switch (type.toUpperCase()) {
      case 'LISTING':
        return 'Listing';
      case 'AVATAR':
        return 'Avatar';
      case 'C3D':
        return 'C3D';
      case 'SCAN_PERSON':
        return 'Scan Person';
      case 'BACKGROUND':
        return 'Background';
      case 'DECORATING':
        return 'Decorating';
      case 'OTHER_PUBLIC':
        return 'Khác (Công khai)';
      case 'OTHER_PRIVATE':
        return 'Khác (Riêng tư)';
      case 'ONM_SHAPE':
        return 'ONM Shape';
      case 'ONM_OBJECT':
        return 'ONM Object';
      case 'ONM_IMAGE':
        return 'ONM Image';
      default:
        return type;
    }
  }

  // Copy text to clipboard
  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copied to clipboard:', text);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  // Modal handlers
  handleViewClick = (album) => {
    this.setState({
      showViewModal: true,
      selectedAlbum: album,
      isEditMode: false
    });
  }

  handleViewAlbumImages = (album) => {
    // Navigate to album detail page
    const { history } = this.props;
    history.push(`/admin/tkt1-media/album-detail/${album.mid}`);
  }

  handleOpenAlbumInNewTab = (album) => {
    // Open album detail page in new tab
    const url = `/admin/tkt1-media/album-detail/${album.mid}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  handleOpenIframeModal = (album) => {
    this.setState({
      showIframeModal: true,
      selectedAlbum: album
    });
  }

  handleCloseIframeModal = () => {
    this.setState({
      showIframeModal: false,
      selectedAlbum: null
    });
  }

  handleEditClick = (album) => {
    // Extract original_listing_id, posted_listing_id and registered_shop_mid from metadata
    const metadata = album.metadata || {};
    const original_listing_id = metadata.original_listing_id || '';
    const posted_listing_id = metadata.posted_listing_id || '';
    const registered_shop_mid = metadata.registered_shop_mid || '';
    
    this.setState({
      showEditModal: true,
      selectedAlbum: album,
      isEditMode: true,
      editFormData: {
        mid: album.mid || '',
        name: album.name || '',
        description: album.description || '',
        cover_url: album.cover_url || '',
        type: album.type || 'PUBLIC',
        status: album.status || 'ACTIVE',
        note: album.note || '',
        username: album.username || '',
        tags: album.tags || [],
        tagsString: Array.isArray(album.tags) ? album.tags.join(', ') : '',
        original_listing_id: original_listing_id,
        posted_listing_id: posted_listing_id,
        registered_shop_mid: registered_shop_mid
      }
    });
  }

  handleCloseViewModal = () => {
    this.setState({
      showViewModal: false,
      selectedAlbum: null,
      isEditMode: false
    });
  }

  handleCloseCreateModal = () => {
    // Get current route type for default type
    const routeType = this.getRouteType();
    const urlQuery = queryString.parse(window.location.search || '');
    const defaultType = urlQuery.type ? String(urlQuery.type).toUpperCase() : (routeType !== 'all' ? routeType : 'OTHER_PUBLIC');
    
    this.setState({
      showCreateModal: false,
      createFormData: {
        mid: '',
        name: '',
        description: '',
        cover_url: '',
        type: defaultType,
        status: 'ACTIVE',
        note: '',
        username: '',
        tags: [],
        tagsString: ''
      }
    });
  }

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedAlbum: null,
      isEditMode: false,
      editFormData: {
        mid: '',
        name: '',
        description: '',
        cover_url: '',
        type: 'OTHER_PUBLIC',
        status: 'ACTIVE',
        note: '',
        username: '',
        tags: [],
        tagsString: '',
        original_listing_id: '',
        posted_listing_id: '',
        registered_shop_mid: ''
      }
    });
  }

  handleOpenImageUploadModal = () => {
    this.setState({ showImageUploadModal: true });
  }

  handleCloseImageUploadModal = () => {
    this.setState({ 
      showImageUploadModal: false,
      uploadedImages: [], // Clear uploaded images to prevent caching
      uploadingImages: false,
      uploadProgress: 0
    });
  }

  handleImagesUploaded = (newImages) => {
    if (newImages && newImages.length > 0) {
      // For cover, we only take the first image
      // Use thumbnail if available, otherwise use main image
      const firstImage = newImages[0];
      const coverUrl = firstImage.thumbnail_url || firstImage.link;
      this.setState(prevState => ({
        createFormData: {
          ...prevState.createFormData,
          cover_url: coverUrl
        },
        editFormData: {
          ...prevState.editFormData,
          cover_url: coverUrl
        },
        uploadedImages: [...prevState.uploadedImages, ...newImages],
        uploadingImages: false,
        uploadProgress: 0
      }));
    }
  }

  // Handle upload progress
  handleUploadProgress = (progress) => {
    this.setState({ uploadProgress: progress });
  }

  // Handle upload start
  handleUploadStart = () => {
    this.setState({ 
      uploadingImages: true,
      uploadProgress: 0 
    });
  }

  // Note modal handlers
  handleNoteClick = (album) => {
    this.setState({
      showNoteModal: true,
      selectedNoteData: {
        mid: album.mid,
        name: album.name,
        note: album.note
      }
    });
  }

  handleCloseNoteModal = () => {
    this.setState({
      showNoteModal: false,
      selectedNoteData: null
    });
  }

  // Helper function to truncate note text
  truncateNote = (note, maxLength = 50) => {
    if (!note || note.length <= maxLength) {
      return note;
    }
    return note.substring(0, maxLength) + '...';
  }

  handleCreateInputChange = (field, value) => {
    this.setState({
      createFormData: {
        ...this.state.createFormData,
        [field]: value
      }
    });
  }

  handleEditInputChange = (field, value) => {
    const newEditFormData = {
      ...this.state.editFormData,
      [field]: value
    };
    
    // Auto-set status to PUBLISHED when posted_listing_id has value
    if (field === 'posted_listing_id' && value && value.trim() !== '') {
      newEditFormData.status = 'PUBLISHED';
    }
    
    this.setState({
      editFormData: newEditFormData
    });
  }

  handleCreateAlbum = async () => {
    const { createFormData } = this.state;
    
    // Validation
    if (!createFormData.name) {
      toast.error('Vui lòng nhập tên album');
      return;
    }

    try {
      // Prepare data without MID and username - backend will generate them automatically
      const { mid, username, original_listing_id, posted_listing_id, registered_shop_mid, ...albumData } = createFormData;
      
      // Add original_listing_id, posted_listing_id and registered_shop_mid to metadata
      const metadata = {
        original_listing_id: original_listing_id,
        posted_listing_id: posted_listing_id,
        registered_shop_mid: registered_shop_mid
      };
      
      // Add metadata to albumData
      albumData.metadata = metadata;
      
      // Call create action
      await this.props.createTKT1ImageAlbum(albumData);
      
      // Close modal
      this.handleCloseCreateModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1ImageAlbums(apiQuery);
      
      toast.success('Tạo album mới thành công!');
    } catch (error) {
      console.error('Error creating album:', error);
      toast.error('Lỗi khi tạo album mới. Vui lòng thử lại.');
    }
  }

  handleSaveEdit = async () => {
    const { selectedAlbum, editFormData } = this.state;
    
    if (!selectedAlbum || !selectedAlbum._id) {
      toast.error('Không tìm thấy thông tin Album để cập nhật');
      return;
    }

    try {
      // Prepare data without MID and username (they shouldn't be updated)
      const { mid, username, original_listing_id, posted_listing_id, registered_shop_mid, ...updateData } = editFormData;
      
      // Auto-set status to PUBLISHED if posted_listing_id has value
      if (posted_listing_id && posted_listing_id.trim() !== '') {
        updateData.status = 'PUBLISHED';
      }
      
      // Add original_listing_id, posted_listing_id and registered_shop_mid to metadata
      const metadata = {
        ...(updateData.metadata || {}),
        original_listing_id: original_listing_id,
        posted_listing_id: posted_listing_id,
        registered_shop_mid: registered_shop_mid
      };
      
      // Add metadata to updateData
      updateData.metadata = metadata;
      
      // Call update action
      await this.props.updateTKT1ImageAlbum(selectedAlbum._id, updateData);
      
      // Close modal
      this.handleCloseEditModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1ImageAlbums(apiQuery);
      
      toast.success('Cập nhật thông tin Album thành công!');
    } catch (error) {
      console.error('Error updating album:', error);
      toast.error('Lỗi khi cập nhật thông tin Album. Vui lòng thử lại.');
    }
  }

  handleDeleteClick = async (album) => {
    if (window.confirm('Bạn có chắc chắn muốn xóa album này?')) {
      try {
        await this.props.deleteTKT1ImageAlbum(album._id);
        
        // Refresh data
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1ImageAlbums(apiQuery);
        
        toast.success('Xóa album thành công!');
      } catch (error) {
        console.error('Error deleting album:', error);
        toast.error('Lỗi khi xóa album. Vui lòng thử lại.');
      }
    }
  }

  // Get date range based on filter option (Hanoi timezone GMT+7)
  getDateRange = (dateFilter) => {
    // Get current time in Hanoi timezone (GMT+7)
    const now = new Date();
    const hanoiTime = new Date(now.getTime() + (7 * 60 * 60 * 1000)); // Add 7 hours for GMT+7
    
    // Create date objects in Hanoi timezone
    const today = new Date(hanoiTime.getFullYear(), hanoiTime.getMonth(), hanoiTime.getDate());
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - today.getDay());
    
    const startOfLastWeek = new Date(startOfWeek);
    startOfLastWeek.setDate(startOfLastWeek.getDate() - 7);
    const endOfLastWeek = new Date(startOfWeek);
    endOfLastWeek.setDate(endOfLastWeek.getDate() - 1);
    
    const startOfMonth = new Date(hanoiTime.getFullYear(), hanoiTime.getMonth(), 1);
    const startOfLastMonth = new Date(hanoiTime.getFullYear(), hanoiTime.getMonth() - 1, 1);
    const endOfLastMonth = new Date(hanoiTime.getFullYear(), hanoiTime.getMonth(), 0);
    
    const startOfYear = new Date(hanoiTime.getFullYear(), 0, 1);
    const startOfLastYear = new Date(hanoiTime.getFullYear() - 1, 0, 1);
    const endOfLastYear = new Date(hanoiTime.getFullYear() - 1, 11, 31);
    
    // Helper function to format date for API (YYYY-MM-DD)
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    
    switch (dateFilter) {
      case 'today':
        return {
          from: formatDate(today),
          to: formatDate(today)
        };
      case 'yesterday':
        return {
          from: formatDate(yesterday),
          to: formatDate(yesterday)
        };
      case 'this_week':
        return {
          from: formatDate(startOfWeek),
          to: formatDate(today)
        };
      case 'last_week':
        return {
          from: formatDate(startOfLastWeek),
          to: formatDate(endOfLastWeek)
        };
      case 'this_month':
        return {
          from: formatDate(startOfMonth),
          to: formatDate(today)
        };
      case 'last_month':
        return {
          from: formatDate(startOfLastMonth),
          to: formatDate(endOfLastMonth)
        };
      case 'this_year':
        return {
          from: formatDate(startOfYear),
          to: formatDate(today)
        };
      case 'last_year':
        return {
          from: formatDate(startOfLastYear),
          to: formatDate(endOfLastYear)
        };
      default:
        return null;
    }
  }

  // Helper function to prepare API query
  prepareApiQuery = (query) => {
    const { showColumns, search, type, status, registered_shop_mid, date_filter, show_sidebar, ...baseQuery } = query;
    const routeType = this.getRouteType();
    
    const apiQuery = {
      ...baseQuery,
      search: search ? search.trim() : ''
    };
    
    // CRITICAL: Always ensure the type matches the current route.
    // If current route is a specific album route, enforce it.
    if (routeType !== 'all') {
      apiQuery.type = routeType;
    } else if (type && String(type).trim()) {
      // When on generic routes (e.g., ORNAMENT flows under /rnd/ornament/*),
      // forward the explicit type from query (e.g., ONM_SHAPE, ONM_OBJECT, ONM_IMAGE)
      apiQuery.type = String(type).trim().toUpperCase();
    }
    
    // Type is already set above based on route - no need to override
    
    // Add status filter if selected (or clear if empty)
    if (status && status.trim()) {
      apiQuery.status = status;
    } else {
      // Clear status filter when "Tất cả" is selected
      apiQuery.status = '';
    }
    
    // Add registered shop filter if selected (or clear if empty)
    if (registered_shop_mid && registered_shop_mid.trim()) {
      apiQuery.registered_shop_mid = registered_shop_mid;
    } else {
      // Clear shop filter when "Tất cả" is selected
      apiQuery.registered_shop_mid = '';
    }
    
    // Add date filter if selected (or clear if empty)
    if (date_filter && date_filter.trim()) {
      const dateRange = this.getDateRange(date_filter);
      if (dateRange) {
        apiQuery.date_from = dateRange.from;
        apiQuery.date_to = dateRange.to;
      }
    } else {
      // Clear date filter when "Tất cả" is selected
      apiQuery.date_from = '';
      apiQuery.date_to = '';
    }
    
    return apiQuery;
  }

  handleChangeItemsPerPage = (e) => {
    const itemsPerPage = parseInt(e.target.value);
    const trimmedQuery = {
      ...this.state.query,
      itemsPerPage,
      currentPage: 1,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    // Save to localStorage with route-specific key
    const routeType = this.getRouteType();
    localStorage.setItem(`tkt1_image_album_query_${routeType}`, JSON.stringify(trimmedQuery));
    
    this.setState({
      query: { ...this.state.query, itemsPerPage, currentPage: 1 }
    }, () => {
      this.updateUrl(trimmedQuery);
      this.props.getTKT1ImageAlbums(apiQuery);
    })
  }

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleSearch();
  }

  handleSearch = () => {
    const trimmedQuery = {
      ...this.state.query,
      search: this.state.query.search.trim()
    };
    
    // Show loading immediately
    this.setState({ loading: true });
    
    // Update state with trimmed query
    this.setState({ query: trimmedQuery }, () => {
      const apiQuery = this.prepareApiQuery(trimmedQuery);
      
      this.updateUrl(trimmedQuery);
      this.loadData(); // Call loadData directly for immediate search
      const routeType = this.getRouteType();
      localStorage.setItem(`tkt1_image_album_query_${routeType}`, JSON.stringify(trimmedQuery));
    });
  }

  updateUrl = (query) => {
    const { history } = this.props;
    const routeType = this.getRouteType();
    // Remove showColumns from URL query - it's only for client display
    const { showColumns, ...urlQuery } = query;
    const queryStr = queryString.stringify(urlQuery);

    // Determine pathname based on route type
    const pathMap = {
      'all': '/admin/tkt1-media/album/all',
      'LISTING': '/admin/tkt1-media/album/listing',
      'AVATAR': '/admin/tkt1-media/album/avatar',
      'C3D': '/admin/tkt1-media/album/c3d',
      'SCAN_PERSON': '/admin/tkt1-media/album/scan-person',
      'BACKGROUND': '/admin/tkt1-media/album/background',
      'DECORATING': '/admin/tkt1-media/album/decorating',
      'OTHER_PUBLIC': '/admin/tkt1-media/album/other-public',
      'OTHER_PRIVATE': '/admin/tkt1-media/album/other-private'
    };

    // Preserve current path for ORNAMENT flows to avoid redirecting to album routes
    const currentPath = window.location.pathname;
    const isOrnamentRoute = currentPath.includes('/rnd/ornament/');

    history.push({
      pathname: isOrnamentRoute ? currentPath : (pathMap[routeType] || '/admin/tkt1-media/album/all'),
      search: queryStr,
    });
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.query.currentPage)
      return;

    const trimmedQuery = {
      ...this.state.query,
      currentPage: newPage,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);

    this.setState({
      query: { ...this.state.query, currentPage: newPage },
    }, () => {
      this.setState({ albums: [] }, () => {
        this.updateUrl(trimmedQuery);
        this.props.getTKT1ImageAlbums(apiQuery);
        const routeType = this.getRouteType();
        localStorage.setItem(`tkt1_image_album_query_${routeType}`, JSON.stringify(trimmedQuery));
      })
    })
  }

  renderSearchFilter = () => {
    return <>
      <Row className="mb-3">
        <Col md="2">
          <InputGroup className="mb-3">
            <InputGroup.Text>Ngày tạo</InputGroup.Text>
            <Form.Select
              value={this.state.query.date_filter}
              onChange={this.handleDateFilterChange}
            >
              <option value="">Tất cả</option>
              <option value="today">Hôm nay</option>
              <option value="yesterday">Hôm qua</option>
              <option value="this_week">Tuần này</option>
              <option value="last_week">Tuần trước</option>
              <option value="this_month">Tháng này</option>
              <option value="last_month">Tháng trước</option>
              <option value="this_year">Năm nay</option>
              <option value="last_year">Năm trước</option>
            </Form.Select>
          </InputGroup>
        </Col>
        {this.shouldShowShopFilter() && (
          <Col md="2">
            <InputGroup>
              <InputGroup.Text>Shop</InputGroup.Text>
              <Form.Select
                value={this.state.query.registered_shop_mid}
                onChange={this.handleShopChange}
              >
                <option value="">Tất cả</option>
                {this.getRegisteredShopOptions().map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
          </Col>
        )}
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Trạng thái</InputGroup.Text>
            <Form.Select
              value={this.state.query.status}
              onChange={this.handleStatusChange}
            >
              <option value="">Tất cả</option>
              <option value="ACTIVE">Hoạt động</option>
              <option value="INACTIVE">Không hoạt động</option>
              <option value="DRAFT">Bản nháp</option>
              <option value="PUBLISHED">Đã xuất bản</option>
              <option value="ARCHIVED">Đã lưu trữ</option>
              <option value="PENDING">Chờ duyệt</option>
              <option value="REJECTED">Từ chối</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup className="mb-3">
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="Tìm kiếm..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        {this.getRouteType() === 'all' && (
          <Col md="2">
            <InputGroup>
              <InputGroup.Text>Loại</InputGroup.Text>
              <Form.Select
                value={this.state.query.type}
                onChange={this.handleTypeChange}
              >
                <option value="">Tất cả</option>
                <option value="LISTING">Listing</option>
                <option value="AVATAR">Avatar</option>
                <option value="C3D">C3D</option>
                <option value="SCAN_PERSON">Scan Person</option>
                <option value="BACKGROUND">Background</option>
                <option value="DECORATING">Decorating</option>
                <option value="OTHER_PUBLIC">Khác (Công khai)</option>
                <option value="OTHER_PRIVATE">Khác (Riêng tư)</option>
                <option value="ONM_SHAPE">ONM Shape</option>
                <option value="ONM_OBJECT">ONM Object</option>
                <option value="ONM_IMAGE">ONM Image</option>
              </Form.Select>
            </InputGroup>
          </Col>
        )}
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Sắp xếp</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortBy}
              onChange={this.handleSelectSort}
            >
              <option value="mid">MID</option>
              <option value="name">Tên</option>
              <option value="created_at">Ngày tạo</option>
              <option value="updated_at">Ngày cập nhật</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="1" className="d-flex align-items-center" style={{marginBottom: '16px'}}>
          <div className="btn-group" role="group">
            <Button
              variant={this.state.query.sortOrder === -1 ? 'primary' : 'outline-secondary'}
              size="sm"
              onClick={() => this.handleSelectSortOrder({ target: { value: '-1' } })}
              title="Giảm dần"
            >
              <FaSortAmountDown />
            </Button>
            <Button
              variant={this.state.query.sortOrder === 1 ? 'primary' : 'outline-secondary'}
              size="sm"
              onClick={() => this.handleSelectSortOrder({ target: { value: '1' } })}
              title="Tăng dần"
            >
              <FaSortAmountUp />
            </Button>
          </div>
        </Col>
        <Col md="1" className="d-flex align-items-center justify-content-end">
          <Button
            className="btn-fill btn"
            type="submit"
            variant="primary"
            onClick={this.handleSubmit}
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </>
  }

  renderAlbumGrid = () => {
    const { albums } = this.props;
    const { showColumns, viewMode, gridSize } = this.state;
    const currentShowColumns = showColumns[viewMode] || showColumns.grid;
    
    // Helper function to get column class based on grid size
    const getColumnClass = () => {
      if (gridSize === 6) {
        return 'col-lg-2 col-md-3 col-sm-6 mb-4';
      } else {
        return 'col-lg-3 col-md-4 col-sm-6 mb-4';
      }
    };
    
    // Ensure albums is an array and filter out any null/undefined items
    const safeAlbums = Array.isArray(albums) ? albums.filter(album => album != null && typeof album === 'object') : [];
    
    // Early return if no data
    if (!safeAlbums || safeAlbums.length === 0) {
      return (
        <div className="text-center py-5">
          <i className="fas fa-folder-open fa-3x text-muted mb-3"></i>
          <h5 className="text-muted">
            {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
          </h5>
        </div>
      );
    }

    return (
      <div className="row">
        {safeAlbums.map((album, index) => {
          if (!album || typeof album !== 'object') return null;
          
          return (
            <div key={album._id || index} className={getColumnClass()}>
              <Card className="h-100 shadow-sm">
                {/* Cover Image */}
                {currentShowColumns.cover_url && (
                  <div className="position-relative" style={{ height: '200px', overflow: 'hidden' }}>
                    {album.cover_url ? (
                      <img 
                        src={album.cover_url} 
                        alt="Cover"
                        className="card-img-top"
                        style={{ 
                          height: '100%', 
                          objectFit: 'cover',
                          cursor: 'pointer'
                        }}
                        onClick={() => this.props.history.push(`/admin/tkt1-media/album-detail/${album.mid}`)}
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                    ) : (
                      <div 
                        className="d-flex align-items-center justify-content-center h-100"
                        style={{ backgroundColor: '#f8f9fa', cursor: 'pointer' }}
                        onClick={() => this.props.history.push(`/admin/tkt1-media/album-detail/${album.mid}`)}
                        title="Click để xem album detail"
                      >
                        <div className="text-center">
                          <FaImage size={40} color="#6c757d" />
                          <div className="mt-2 small text-muted">No Cover</div>
                        </div>
                      </div>
                    )}
                    
                    {/* Error fallback */}
                    <div 
                      className="d-none align-items-center justify-content-center h-100"
                      style={{ backgroundColor: '#f8f9fa' }}
                    >
                      <div className="text-center">
                        <FaImage size={40} color="#6c757d" />
                        <div className="mt-2 small text-muted">Lỗi hiển thị</div>
                      </div>
                    </div>
                    
                    {/* Status badge */}
                    {currentShowColumns.status && (
                      <div className="position-absolute top-0 end-0 m-2">
                        <Badge 
                          bg={
                            album.metadata?.posted_listing_id ? 'success' :
                            album.status === 'ACTIVE' ? 'success' :
                            album.status === 'INACTIVE' ? 'warning' :
                            album.status === 'DRAFT' ? 'info' :
                            album.status === 'PUBLISHED' ? 'primary' :
                            album.status === 'ARCHIVED' ? 'secondary' :
                            album.status === 'PENDING' ? 'warning' :
                            album.status === 'REJECTED' ? 'danger' :
                            'secondary'
                          }
                          style={{ fontSize: '0.7em' }}
                        >
                          {this.mapStatus(album.status, album)}
                        </Badge>
                      </div>
                    )}
                    
                    {/* Type badge */}
                    {currentShowColumns.type && (
                      <div className="position-absolute top-0 start-0 m-2">
                        <Badge 
                          bg={
                            album.type === 'LISTING' ? 'primary' :
                            album.type === 'AVATAR' ? 'info' :
                            album.type === 'C3D' ? 'success' :
                            album.type === 'SCAN_PERSON' ? 'warning' :
                            album.type === 'BACKGROUND' ? 'info' :
                            album.type === 'DECORATING' ? 'warning' :
                            album.type === 'OTHER_PUBLIC' ? 'secondary' :
                            album.type === 'OTHER_PRIVATE' ? 'dark' :
                            album.type === 'ONM_SHAPE' ? 'secondary' :
                            album.type === 'ONM_OBJECT' ? 'secondary' :
                            album.type === 'ONM_IMAGE' ? 'secondary' :
                            'light'
                          }
                          style={{ fontSize: '0.7em' }}
                        >
                          {this.mapType(album.type)}
                        </Badge>
                      </div>
                    )}
                  </div>
                )}
                
                <Card.Body className="d-flex flex-column">
                  {/* Album name */}
                  <Card.Title className="h6 mb-2" style={{ fontSize: '0.9em' }}>
                    <div 
                      className="d-flex align-items-center cursor-pointer"
                      onClick={() => this.props.history.push(`/admin/tkt1-media/album-detail/${album.mid}`)}
                      style={{ cursor: 'pointer' }}
                      title="Click để xem album detail"
                    >
                      <FaImage className="text-primary me-2" />
                      <span 
                        className="text-truncate" 
                        title={album.name}
                      >
                        {album.name || '-'}
                      </span>
                    </div>
                  </Card.Title>
                  
                  {/* Album info */}
                  <div className="mb-2">
                    {currentShowColumns.mid && (
                      <div className="small text-muted d-flex align-items-center gap-2">
                        <strong>MID: </strong> 
                        <span>
                          {album.mid || '-'}
                        </span>
                        {album.mid && (
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(album.mid)}
                            title="Copy MID"
                          />
                        )}
                      </div>
                    )}
                    {currentShowColumns.description && album.description && (
                      <div className="small text-muted">
                        <strong>Mô tả:</strong> {album.description.length > 50 ? 
                          album.description.substring(0, 50) + '...' : album.description
                        }
                      </div>
                    )}
                    {currentShowColumns.username && (
                      <div className="small text-muted">
                        <strong>Người tạo:</strong> {album.username || '-'}
                      </div>
                    )}
                    {currentShowColumns.created_at && (
                      <div className="small text-muted">
                        <strong>Ngày tạo:</strong> {album.created_at ? 
                          new Date(album.created_at).toLocaleString('vi-VN', {
                            timeZone: 'Asia/Ho_Chi_Minh',
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit'
                          }) : '-'
                        }
                      </div>
                    )}
                    {currentShowColumns.tags && album.tags && album.tags.length > 0 && (
                      <div className="small text-muted">
                        <strong>Tags:</strong> {album.tags.slice(0, 2).join(', ')}
                        {album.tags.length > 2 && ` +${album.tags.length - 2}`}
                      </div>
                    )}
                    {currentShowColumns.note && album.note && (
                      <div className="small text-muted">
                        <strong>Ghi chú:</strong> {album.note.length > 30 ? 
                          album.note.substring(0, 30) + '...' : album.note
                        }
                      </div>
                    )}
                    {currentShowColumns.listing_id && album.metadata?.original_listing_id && (
                      <div className="small text-muted">
                        <strong>Original Listing:</strong> 
                        <a 
                          href={`https://etsy.com/listing/${album.metadata.original_listing_id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="ms-1 text-decoration-none"
                          style={{ color: '#007bff' }}
                          title={`View original listing ${album.metadata.original_listing_id} on Etsy`}
                        >
                          {album.metadata.original_listing_id}
                        </a>
                      </div>
                    )}
                    {currentShowColumns.listing_id && album.metadata?.posted_listing_id && (
                      <div className="small text-muted">
                        <strong>Posted Listing:</strong> 
                        <a 
                          href={`https://etsy.com/listing/${album.metadata.posted_listing_id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="ms-1 text-decoration-none"
                          style={{ color: '#007bff' }}
                          title={`View posted listing ${album.metadata.posted_listing_id} on Etsy`}
                        >
                          {album.metadata.posted_listing_id}
                        </a>
                      </div>
                    )}
                    {currentShowColumns.shop && album.metadata?.registered_shop_mid && (
                      <div className="small text-muted">
                        <strong>Shop:</strong> 
                        <a 
                          href={`https://etsy.com/shop/${this.getShopNameFromMid(album.metadata.registered_shop_mid)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="ms-1 text-decoration-none"
                          style={{ color: '#007bff' }}
                          title={`View shop ${this.getShopNameFromMid(album.metadata.registered_shop_mid)} on Etsy`}
                        >
                          {album.metadata.registered_shop_mid} - {this.getShopNameFromMid(album.metadata.registered_shop_mid)}
                        </a>
                      </div>
                    )}
                  </div>
                  
                  {/* Actions */}
                  <div className="mt-auto">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="btn-group btn-group-sm" role="group">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={() => this.handleOpenIframeModal(album)}
                          title="Mở album trong cửa sổ mới"
                        >
                          <FaEye size={12} />
                        </Button>
                        <Button
                          variant="outline-info"
                          size="sm"
                          onClick={() => this.handleViewClick(album)}
                          title="Xem thông tin album"
                        >
                          <FaInfo size={12} />
                        </Button>
                        <Button
                          variant="outline-success"
                          size="sm"
                          onClick={() => this.handleOpenAlbumInNewTab(album)}
                          title="Mở album trong tab mới"
                        >
                          <FaExternalLinkAlt size={12} />
                        </Button>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={() => this.handleEditClick(album)}
                          title="Chỉnh sửa"
                        >
                          <FaPencilAlt size={12} />
                        </Button>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => this.handleDeleteClick(album)}
                          title="Xóa"
                        >
                          <FaTrash size={12} />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          );
        })}
      </div>
    );
  }

  renderAlbumTable = () => {
    const { albums } = this.props;
    const { showColumns, columnWidths, viewMode } = this.state;
    const currentShowColumns = showColumns[viewMode] || showColumns.list;
    
    // Ensure albums is an array and filter out any null/undefined items
    const safeAlbums = Array.isArray(albums) ? albums.filter(album => album != null && typeof album === 'object') : [];
    
    // Early return if no data to prevent any rendering issues
    if (!safeAlbums || safeAlbums.length === 0) {
      return (
        <Table striped bordered hover style={{ tableLayout: 'auto' }}>
          <thead>
            <tr>
              <th style={{ width: `${columnWidths.stt}px`, position: 'relative' }}>
                STT
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'stt')}
                />
              </th>
              {currentShowColumns.mid && <th style={{ width: `${columnWidths.mid}px`, position: 'relative' }}>
                MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'mid')}
                />
              </th>}
              {currentShowColumns.cover_url && <th style={{ width: `${columnWidths.cover_url}px`, position: 'relative' }}>
                Ảnh bìa
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'cover_url')}
                />
              </th>}
              {currentShowColumns.name && <th style={{ width: `${columnWidths.name}px`, position: 'relative' }}>
                Tên album
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'name')}
                />
              </th>}
              {currentShowColumns.description && <th style={{ width: `${columnWidths.description}px`, position: 'relative' }}>
                Mô tả
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'description')}
                />
              </th>}
              {currentShowColumns.type && <th style={{ width: `${columnWidths.type}px`, position: 'relative' }}>
                Loại
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'type')}
                />
              </th>}
              {currentShowColumns.status && <th style={{ width: `${columnWidths.status}px`, position: 'relative' }}>
                Trạng thái
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'status')}
                />
              </th>}
              {currentShowColumns.username && <th style={{ width: `${columnWidths.username}px`, position: 'relative' }}>
                Người tạo
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'username')}
                />
              </th>}
              {currentShowColumns.tags && <th style={{ width: `${columnWidths.tags}px`, position: 'relative' }}>
                Tags
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'tags')}
                />
              </th>}
              {currentShowColumns.note && <th style={{ width: `${columnWidths.note}px`, position: 'relative' }}>
                Ghi chú
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'note')}
                />
              </th>}
              {currentShowColumns.listing_id && <th style={{ width: `${columnWidths.listing_id}px`, position: 'relative' }}>
                Listing
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'listing_id')}
                />
              </th>}
              {currentShowColumns.shop && <th style={{ width: `${columnWidths.shop}px`, position: 'relative' }}>
                Shop
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'shop')}
                />
              </th>}
              {currentShowColumns.created_at && <th style={{ width: `${columnWidths.created_at}px`, position: 'relative' }}>
                Ngày tạo
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'created_at')}
                />
              </th>}
              {currentShowColumns.updated_at && <th style={{ width: `${columnWidths.updated_at}px`, position: 'relative' }}>
                Ngày cập nhật
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'updated_at')}
                />
              </th>}
              <th style={{ width: `${columnWidths.actions}px` }}>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={Object.values(currentShowColumns).filter(Boolean).length + 2} className="text-center">
                {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }
    
    return (
      <Table striped bordered hover style={{ tableLayout: 'auto' }}>
        <thead>
          <tr>
            <th style={{ width: `${columnWidths.stt}px`, position: 'relative' }}>
              STT
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'stt')}
              />
            </th>
            {currentShowColumns.mid && <th style={{ width: `${columnWidths.mid}px`, position: 'relative' }}>
              MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'mid')}
              />
            </th>}
            {currentShowColumns.cover_url && <th style={{ width: `${columnWidths.cover_url}px`, position: 'relative' }}>
              Ảnh bìa
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'cover_url')}
              />
            </th>}
            {currentShowColumns.name && <th style={{ width: `${columnWidths.name}px`, position: 'relative' }}>
              Tên album
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'name')}
              />
            </th>}
            {currentShowColumns.description && <th style={{ width: `${columnWidths.description}px`, position: 'relative' }}>
              Mô tả
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'description')}
              />
            </th>}
            {currentShowColumns.type && <th style={{ width: `${columnWidths.type}px`, position: 'relative' }}>
              Loại
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'type')}
              />
            </th>}
            {currentShowColumns.status && <th style={{ width: `${columnWidths.status}px`, position: 'relative' }}>
              Trạng thái
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'status')}
              />
            </th>}
            {currentShowColumns.username && <th style={{ width: `${columnWidths.username}px`, position: 'relative' }}>
              Người tạo
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'username')}
              />
            </th>}
            {currentShowColumns.tags && <th style={{ width: `${columnWidths.tags}px`, position: 'relative' }}>
              Tags
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'tags')}
              />
            </th>}
            {currentShowColumns.note && <th style={{ width: `${columnWidths.note}px`, position: 'relative' }}>
              Ghi chú
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'note')}
              />
            </th>}
            {currentShowColumns.listing_id && <th style={{ width: `${columnWidths.listing_id}px`, position: 'relative' }}>
              Listing
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'listing_id')}
              />
            </th>}
            {currentShowColumns.shop && <th style={{ width: `${columnWidths.shop}px`, position: 'relative' }}>
              Shop
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'shop')}
              />
            </th>}
            {currentShowColumns.created_at && <th style={{ width: `${columnWidths.created_at}px`, position: 'relative' }}>
              Ngày tạo
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'created_at')}
              />
            </th>}
            {currentShowColumns.updated_at && <th style={{ width: `${columnWidths.updated_at}px`, position: 'relative' }}>
              Ngày cập nhật
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'updated_at')}
              />
            </th>}
            <th style={{ width: `${columnWidths.actions}px` }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safeAlbums.map((album, index) => {
            if (!album || typeof album !== 'object') return null;
              
              return (
                <tr key={album._id || index}>
                  <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
                  {currentShowColumns.mid && (
                    <td>
                      {album.mid ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge 
                            bg="info" 
                            style={{ 
                              fontSize: '0.9em', 
                              padding: '6px 10px',
                              cursor: 'pointer'
                            }}
                            onClick={() => this.props.history.push(`/admin/tkt1-media/album-detail/${album.mid}`)}
                            title="Click để xem album detail"
                          >
                            {album.mid}
                          </Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(album.mid)}
                            title="Copy MID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {currentShowColumns.cover_url && (
                    <td>
                      {album.cover_url ? (
                        <img 
                          src={album.cover_url} 
                          alt="Cover"
                          style={{ 
                            width: '40px', 
                            height: '40px', 
                            objectFit: 'cover',
                            borderRadius: '4px',
                            border: '2px solid #dee2e6',
                            cursor: 'pointer'
                          }}
                          onClick={() => this.props.history.push(`/admin/tkt1-media/album-detail/${album.mid}`)}
                          title="Click để xem album detail"
                        />
                      ) : (
                        <div 
                          style={{ 
                            width: '40px', 
                            height: '40px', 
                            backgroundColor: '#f8f9fa',
                            borderRadius: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '2px solid #dee2e6',
                            cursor: 'pointer'
                          }}
                          onClick={() => this.props.history.push(`/admin/tkt1-media/album-detail/${album.mid}`)}
                          title="Click để xem album detail"
                        >
                          <FaImage size={16} color="#6c757d" />
                        </div>
                      )}
                    </td>
                  )}
                  {currentShowColumns.name && (
                    <td>
                      <div 
                        style={{ 
                          whiteSpace: 'nowrap', 
                          cursor: 'pointer',
                          color: '#007bff'
                        }} 
                        title={`${album.name} - Click để xem album detail`}
                        onClick={() => this.props.history.push(`/admin/tkt1-media/album-detail/${album.mid}`)}
                      >
                        {album.name || '-'}
                      </div>
                    </td>
                  )}
                  {currentShowColumns.description && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} title={album.description}>
                        {album.description || '-'}
                      </div>
                    </td>
                  )}
                  {currentShowColumns.type && (
                    <td>
                      {album.type ? (
                        <Badge 
                          bg={
                            album.type === 'LISTING' ? 'primary' :
                            album.type === 'AVATAR' ? 'info' :
                            album.type === 'C3D' ? 'success' :
                            album.type === 'SCAN_PERSON' ? 'warning' :
                            album.type === 'BACKGROUND' ? 'info' :
                            album.type === 'DECORATING' ? 'warning' :
                            album.type === 'OTHER_PUBLIC' ? 'secondary' :
                            album.type === 'OTHER_PRIVATE' ? 'dark' :
                      album.type === 'ONM_SHAPE' ? 'secondary' :
                      album.type === 'ONM_OBJECT' ? 'secondary' :
                      album.type === 'ONM_IMAGE' ? 'secondary' :
                            'light'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapType(album.type)}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {currentShowColumns.status && (
                    <td>
                      {album.status ? (
                        <Badge 
                          bg={
                            album.metadata?.posted_listing_id ? 'success' :
                            album.status === 'ACTIVE' ? 'success' :
                            album.status === 'INACTIVE' ? 'warning' :
                            album.status === 'DRAFT' ? 'info' :
                            album.status === 'PUBLISHED' ? 'primary' :
                            album.status === 'ARCHIVED' ? 'secondary' :
                            album.status === 'PENDING' ? 'warning' :
                            album.status === 'REJECTED' ? 'danger' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(album.status, album)}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {currentShowColumns.username && (
                    <td>
                      {album.username || '-'}
                    </td>
                  )}
                  {currentShowColumns.tags && (
                    <td>
                      {album.tags && album.tags.length > 0 ? (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2px' }}>
                          {album.tags.slice(0, 3).map((tag, tagIndex) => (
                            <Badge key={tagIndex} bg="light" text="dark" style={{ fontSize: '0.7em' }}>
                              {tag}
                            </Badge>
                          ))}
                          {album.tags.length > 3 && (
                            <Badge bg="secondary" style={{ fontSize: '0.7em' }}>
                              +{album.tags.length - 3}
                            </Badge>
                          )}
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {currentShowColumns.note && (
                    <td>
                      {album.note ? (
                        <div className="d-flex align-items-center gap-2">
                          <span 
                            style={{ 
                              whiteSpace: 'nowrap',
                              cursor: album.note.length > 100 ? 'pointer' : 'default'
                            }}
                            title={album.note}
                          >
                            {this.truncateNote(album.note)}
                          </span>
                          {album.note.length > 100 && (
                            <FaStickyNote 
                              size={12} 
                              style={{ 
                                cursor: 'pointer', 
                                color: '#6c757d',
                                flexShrink: 0
                              }}
                              onClick={() => this.handleNoteClick(album)}
                              title="Xem đầy đủ ghi chú"
                            />
                          )}
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {currentShowColumns.listing_id && (
                    <td>
                      <div className="d-flex flex-column gap-1">
                        {album.metadata?.original_listing_id ? (
                          <a 
                            href={`https://etsy.com/listing/${album.metadata.original_listing_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-decoration-none"
                            title={`View original listing ${album.metadata.original_listing_id} on Etsy`}
                          >
                            <Badge bg="info" style={{ fontSize: '0.7em', padding: '2px 6px', cursor: 'pointer' }}>
                              Original: {album.metadata.original_listing_id}
                            </Badge>
                          </a>
                        ) : null}
                        {album.metadata?.posted_listing_id ? (
                          <a 
                            href={`https://etsy.com/listing/${album.metadata.posted_listing_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-decoration-none"
                            title={`View posted listing ${album.metadata.posted_listing_id} on Etsy`}
                          >
                            <Badge bg="primary" style={{ fontSize: '0.7em', padding: '2px 6px', cursor: 'pointer' }}>
                              Posted: {album.metadata.posted_listing_id}
                            </Badge>
                          </a>
                        ) : null}
                        {!album.metadata?.original_listing_id && !album.metadata?.posted_listing_id && '-'}
                      </div>
                    </td>
                  )}
                  {currentShowColumns.shop && (
                    <td>
                      {album.metadata?.registered_shop_mid ? (
                        <a 
                          href={`https://etsy.com/shop/${this.getShopNameFromMid(album.metadata.registered_shop_mid)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none"
                          title={`View shop ${this.getShopNameFromMid(album.metadata.registered_shop_mid)} on Etsy`}
                        >
                          <Badge bg="success" style={{ fontSize: '0.8em', padding: '4px 8px', cursor: 'pointer' }}>
                            {album.metadata.registered_shop_mid} - {this.getShopNameFromMid(album.metadata.registered_shop_mid)}
                          </Badge>
                        </a>
                      ) : '-'}
                    </td>
                  )}
                  {currentShowColumns.created_at && (
                    <td>
                      {album.created_at ? 
                        new Date(album.created_at).toLocaleString('vi-VN', {
                          timeZone: 'Asia/Ho_Chi_Minh',
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit'
                        }) : 
                        '-'
                      }
                    </td>
                  )}
                  {currentShowColumns.updated_at && (
                    <td>
                      {album.updated_at ? 
                        new Date(album.updated_at).toLocaleString('vi-VN', {
                          timeZone: 'Asia/Ho_Chi_Minh',
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit'
                        }) : 
                        '-'
                      }
                    </td>
                  )}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <FaEye 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Xem thông tin"
                        onClick={() => this.handleViewClick(album)}
                      />
                      <FaExpand 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#17a2b8'
                        }}
                        title="Mở album trong cửa sổ mới"
                        onClick={() => this.handleOpenIframeModal(album)}
                      />
                      <FaPencilAlt 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Chỉnh sửa"
                        onClick={() => this.handleEditClick(album)}
                      />
                      <FaTrash 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#dc3545'
                        }}
                        title="Xóa"
                        onClick={() => this.handleDeleteClick(album)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    );
  }

  render() {
    const { columnWidths } = this.state;
    
    return (
      <>
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary">
                {(() => {
                  const routeType = this.getRouteType();
                  const titleMap = {
                    'all': 'TKT1 Image Album - All',
                    'LISTING': 'TKT1 Image Album - Listing',
                    'AVATAR': 'TKT1 Image Album - Avatar',
      'C3D': 'TKT1 Image Album - C3D',
      'SCAN_PERSON': 'TKT1 Image Album - Scan Person',
      'BACKGROUND': 'TKT1 Image Album - Background',
      'DECORATING': 'TKT1 Image Album - Decorating',
      'OTHER_PUBLIC': 'TKT1 Image Album - Other Public',
      'OTHER_PRIVATE': 'TKT1 Image Album - Other Private',
      'ONM_SHAPE': 'TKT1 Image Album - ONM Shape',
      'ONM_OBJECT': 'TKT1 Image Album - ONM Object',
      'ONM_IMAGE': 'TKT1 Image Album - ONM Image'
                  };
                  return titleMap[routeType] || 'TKT1 Image Album';
                })()}
              </h2>
            </Col>
            <Col className="text-end">
              <Button 
                variant="success" 
                onClick={() => this.setState({ showCreateModal: true })}
                className="me-2"
              >
                <i className="fas fa-plus me-1"></i>
                Thêm Album mới
              </Button>
            </Col>
          </Row>
          {this.renderSearchFilter()}
          
          {/* Loading Indicator */}
          {this.state.loading && (
            <Row className="mb-3">
              <Col className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Đang tải...</span>
                </div>
                <p className="mt-2 text-muted">Đang tải dữ liệu...</p>
              </Col>
            </Row>
          )}
          
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>Tìm thấy <span className='text-danger'>{this.props.totalCount}</span> bản ghi:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <Button 
                  variant="secondary" 
                  size="sm"
                  className="me-2"
                  onClick={() => this.setState({ showConfigModal: true })}
                >
                  <i className="fas fa-cog"></i> Cấu hình hiển thị
                </Button>
                <div className="btn-group me-2" role="group">
                  <Button
                    variant={this.state.viewMode === 'list' ? 'primary' : 'outline-secondary'}
                    size="sm"
                    onClick={() => this.handleViewModeToggle('list')}
                    title="Chế độ danh sách"
                  >
                    <FaList />
                  </Button>
                  <Button
                    variant={this.state.viewMode === 'grid' ? 'primary' : 'outline-secondary'}
                    size="sm"
                    onClick={() => this.handleViewModeToggle('grid')}
                    title="Chế độ lưới"
                  >
                    <FaTh />
                  </Button>
                </div>
                {this.state.viewMode === 'grid' && (
                  <div className="btn-group me-2" role="group">
                    <Button
                      variant={this.state.gridSize === 4 ? 'primary' : 'outline-secondary'}
                      size="sm"
                      onClick={() => this.handleGridSizeToggle(4)}
                      title="4 items per row"
                    >
                      <FaThLarge />
                    </Button>
                    <Button
                      variant={this.state.gridSize === 6 ? 'primary' : 'outline-secondary'}
                      size="sm"
                      onClick={() => this.handleGridSizeToggle(6)}
                      title="6 items per row"
                    >
                      <FaThList />
                    </Button>
                  </div>
                )}
                <div className="d-inline-block ms-3">
                  <span className="me-2">Số bản ghi/trang:</span>
                  <Form.Select
                    size="sm"
                    value={this.state.query.itemsPerPage}
                    onChange={this.handleChangeItemsPerPage}
                    style={{ width: '100px', display: 'inline-block' }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={200}>200</option>
                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {this.state.viewMode === 'list' ? (
                <div className="sticky-table">
                  {this.renderAlbumTable()}
                </div>
              ) : (
                this.renderAlbumGrid()
              )}
            </Col>
          </Row>
        </Container>
        <Pagination 
          totalItems={this.props.totalCount} 
          itemsPerPage={this.state.query.itemsPerPage} 
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage} 
          updatePage={this.updatePage} 
        />

        {/* Configuration Modal */}
        <Modal show={this.state.showConfigModal} onHide={() => this.setState({ showConfigModal: false })} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Cấu hình hiển thị</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {/* Mode Selection */}
              <div className="mb-4">
                <h6 className="text-primary">Chọn chế độ cấu hình</h6>
                <div className="btn-group w-100" role="group">
                  <Button
                    variant={this.state.configMode === 'list' ? 'primary' : 'outline-secondary'}
                    onClick={() => this.setState({ configMode: 'list' })}
                  >
                    <FaList className="me-2" />
                    Cấu hình List View
                  </Button>
                  <Button
                    variant={this.state.configMode === 'grid' ? 'primary' : 'outline-secondary'}
                    onClick={() => this.setState({ configMode: 'grid' })}
                  >
                    <FaTh className="me-2" />
                    Cấu hình Grid View
                  </Button>
                </div>
              </div>
              
              <hr />
              
              {/* Column Configuration */}
              <div className="mb-3">
                <h6>
                  Hiển thị cột cho <strong>{this.state.configMode === 'list' ? 'List View' : 'Grid View'}</strong>
                </h6>
                <div className="row">
                  {Object.entries(this.state.showColumns[this.state.configMode] || {}).map(([column, isVisible]) => {
                    const columnLabels = {
                      mid: 'MID',
                      name: 'Tên album',
                      description: 'Mô tả',
                      cover_url: 'Ảnh bìa',
                      type: 'Loại',
                      status: 'Trạng thái',
                      username: 'Người tạo',
                      tags: 'Tags',
                      note: 'Ghi chú',
                      listing_id: 'Original & Posted Listing',
                      shop: 'Shop',
                      created_at: 'Ngày tạo',
                      updated_at: 'Ngày cập nhật'
                    };
                    
                    return (
                      <div key={column} className="col-md-6 col-lg-4">
                        <Form.Check
                          type="switch"
                          id={`column-${this.state.configMode}-${column}`}
                          label={columnLabels[column] || column}
                          checked={isVisible}
                          onChange={() => this.handleColumnToggle(column)}
                          className="mb-2"
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
              
              {/* Info */}
              <div className="alert alert-info">
                <i className="fas fa-info-circle me-2"></i>
                <strong>Lưu ý:</strong> Cấu hình được lưu riêng cho từng chế độ xem. 
                {this.state.configMode === 'list' 
                  ? ' List View hiển thị tất cả thông tin chi tiết trong bảng.' 
                  : ' Grid View hiển thị thông tin cơ bản trong card layout.'
                }
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showConfigModal: false })}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* View Modal */}
        <Modal show={this.state.showViewModal} onHide={this.handleCloseViewModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thông tin Album</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedAlbum && (
              <div>
                {/* Basic Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin cơ bản</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>MID:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedAlbum.mid}
                      </Badge>
                      {this.state.selectedAlbum.mid && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedAlbum.mid)}
                          title="Copy MID"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Tên album:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedAlbum.name || '-'}</span>
                      {this.state.selectedAlbum.name && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedAlbum.name)}
                          title="Copy Name"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Loại:</strong> 
                    <div className="mt-1">
                      {this.state.selectedAlbum.type ? (
                        <Badge 
                          bg={
                            this.state.selectedAlbum.type === 'LISTING' ? 'primary' :
                            this.state.selectedAlbum.type === 'AVATAR' ? 'info' :
                            this.state.selectedAlbum.type === 'C3D' ? 'success' :
                            this.state.selectedAlbum.type === 'SCAN_PERSON' ? 'warning' :
                            this.state.selectedAlbum.type === 'BACKGROUND' ? 'info' :
                            this.state.selectedAlbum.type === 'DECORATING' ? 'warning' :
                            this.state.selectedAlbum.type === 'OTHER_PUBLIC' ? 'secondary' :
                            this.state.selectedAlbum.type === 'OTHER_PRIVATE' ? 'dark' :
                            'light'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapType(this.state.selectedAlbum.type)}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Trạng thái:</strong> 
                    <div className="mt-1">
                      {this.state.selectedAlbum.status ? (
                        <Badge 
                          bg={
                            this.state.selectedAlbum.metadata?.posted_listing_id ? 'success' :
                            this.state.selectedAlbum.status === 'ACTIVE' ? 'success' :
                            this.state.selectedAlbum.status === 'INACTIVE' ? 'warning' :
                            this.state.selectedAlbum.status === 'DRAFT' ? 'info' :
                            this.state.selectedAlbum.status === 'PUBLISHED' ? 'primary' :
                            this.state.selectedAlbum.status === 'ARCHIVED' ? 'secondary' :
                            this.state.selectedAlbum.status === 'PENDING' ? 'warning' :
                            this.state.selectedAlbum.status === 'REJECTED' ? 'danger' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(this.state.selectedAlbum.status, this.state.selectedAlbum)}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Description */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Mô tả</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <div style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedAlbum.description || '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Cover Image */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Ảnh bìa</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12" className="text-center">
                    {this.state.selectedAlbum.cover_url ? (
                      <img 
                        src={this.state.selectedAlbum.cover_url} 
                        alt="Cover"
                        style={{ 
                          maxWidth: '300px', 
                          maxHeight: '300px', 
                          objectFit: 'cover',
                          borderRadius: '8px',
                          border: '3px solid #dee2e6'
                        }}
                      />
                    ) : (
                      <div 
                        style={{ 
                          width: '300px', 
                          height: '200px', 
                          backgroundColor: '#f8f9fa',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '3px dashed #dee2e6',
                          margin: '0 auto'
                        }}
                      >
                        <FaImage size={50} color="#6c757d" />
                      </div>
                    )}
                  </Col>
                </Row>
                
                {/* Additional Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin bổ sung</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Original Listing:</strong> 
                    <div className="mt-1">
                      {this.state.selectedAlbum.metadata?.original_listing_id ? (
                        <a 
                          href={`https://etsy.com/listing/${this.state.selectedAlbum.metadata.original_listing_id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none"
                          title={`View original listing ${this.state.selectedAlbum.metadata.original_listing_id} on Etsy`}
                        >
                          <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px', cursor: 'pointer' }}>
                            {this.state.selectedAlbum.metadata.original_listing_id}
                          </Badge>
                        </a>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Posted Listing:</strong> 
                    <div className="mt-1">
                      {this.state.selectedAlbum.metadata?.posted_listing_id ? (
                        <a 
                          href={`https://etsy.com/listing/${this.state.selectedAlbum.metadata.posted_listing_id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none"
                          title={`View posted listing ${this.state.selectedAlbum.metadata.posted_listing_id} on Etsy`}
                        >
                          <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px', cursor: 'pointer' }}>
                            {this.state.selectedAlbum.metadata.posted_listing_id}
                          </Badge>
                        </a>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Shop:</strong> 
                    <div className="mt-1">
                      {this.state.selectedAlbum.metadata?.registered_shop_mid ? (
                        <a 
                          href={`https://etsy.com/shop/${this.getShopNameFromMid(this.state.selectedAlbum.metadata.registered_shop_mid)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none"
                          title={`View shop ${this.getShopNameFromMid(this.state.selectedAlbum.metadata.registered_shop_mid)} on Etsy`}
                        >
                          <Badge bg="success" style={{ fontSize: '0.9em', padding: '6px 10px', cursor: 'pointer' }}>
                            {this.state.selectedAlbum.metadata.registered_shop_mid} - {this.getShopNameFromMid(this.state.selectedAlbum.metadata.registered_shop_mid)}
                          </Badge>
                        </a>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Người tạo:</strong> 
                    <div className="mt-1">
                      {this.state.selectedAlbum.username || '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Tags:</strong> 
                    <div className="mt-1">
                      {this.state.selectedAlbum.tags && this.state.selectedAlbum.tags.length > 0 ? (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                          {this.state.selectedAlbum.tags.map((tag, tagIndex) => (
                            <Badge key={tagIndex} bg="light" text="dark" style={{ fontSize: '0.8em' }}>
                              {tag}
                            </Badge>
                          ))}
                        </div>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ngày tạo:</strong> 
                    <div className="mt-1">
                      {this.state.selectedAlbum.created_at ? 
                        new Date(this.state.selectedAlbum.created_at).toLocaleString('vi-VN', {
                          timeZone: 'Asia/Ho_Chi_Minh',
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit'
                        }) : 
                        '-'
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ngày cập nhật:</strong> 
                    <div className="mt-1">
                      {this.state.selectedAlbum.updated_at ? 
                        new Date(this.state.selectedAlbum.updated_at).toLocaleString('vi-VN', {
                          timeZone: 'Asia/Ho_Chi_Minh',
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit'
                        }) : 
                        '-'
                      }
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Ghi chú:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedAlbum.note || '-'}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseViewModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Create Modal */}
        <Modal show={this.state.showCreateModal} onHide={this.handleCloseCreateModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thêm Album mới</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Tên album <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.name}
                      onChange={(e) => this.handleCreateInputChange('name', e.target.value)}
                      placeholder="Nhập tên album"
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              {/* Auto-generated fields info */}
              <Row className="mb-3">
                <Col md="12">
                  <div className="alert alert-info">
                    <i className="fas fa-info-circle me-2"></i>
                    <strong>Thông tin tự động:</strong> MID và Username sẽ được hệ thống tạo tự động khi tạo album mới.
                  </div>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Loại</Form.Label>
                    <Form.Select
                      value={this.state.createFormData.type}
                      onChange={(e) => this.handleCreateInputChange('type', e.target.value)}
                      disabled
                      className="bg-light"
                    >
                      <option value="LISTING">Listing</option>
                      <option value="AVATAR">Avatar</option>
                      <option value="C3D">C3D</option>
                      <option value="SCAN_PERSON">Scan Person</option>
                      <option value="BACKGROUND">Background</option>
                      <option value="DECORATING">Decorating</option>
                      <option value="OTHER_PUBLIC">Khác (Công khai)</option>
                      <option value="OTHER_PRIVATE">Khác (Riêng tư)</option>
                      <option value="ONM_SHAPE">ONM Shape</option>
                      <option value="ONM_OBJECT">ONM Object</option>
                      <option value="ONM_IMAGE">ONM Image</option>
                    </Form.Select>
                    <Form.Text className="text-muted">
                      Loại album được xác định theo route hiện tại
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.createFormData.status}
                      onChange={(e) => this.handleCreateInputChange('status', e.target.value)}
                    >
                      <option value="ACTIVE">Hoạt động</option>
                      <option value="INACTIVE">Không hoạt động</option>
                      <option value="DRAFT">Bản nháp</option>
                      <option value="PUBLISHED">Đã xuất bản</option>
                      <option value="ARCHIVED">Đã lưu trữ</option>
                      <option value="PENDING">Chờ duyệt</option>
                      <option value="REJECTED">Từ chối</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              {this.shouldShowListingFields() && (
                <Row className="mb-3">
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Original Listing ID</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.createFormData.original_listing_id}
                        onChange={(e) => this.handleCreateInputChange('original_listing_id', e.target.value)}
                        placeholder="Nhập Original Listing ID"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Posted Listing ID</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.createFormData.posted_listing_id}
                        onChange={(e) => this.handleCreateInputChange('posted_listing_id', e.target.value)}
                        placeholder="Nhập Posted Listing ID"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )}
              
              {this.shouldShowShopField() && (
                <Row className="mb-3">
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Shop</Form.Label>
                      <Form.Select
                        value={this.state.createFormData.registered_shop_mid}
                        onChange={(e) => this.handleCreateInputChange('registered_shop_mid', e.target.value)}
                      >
                        <option value="">Chọn Shop</option>
                        {this.getRegisteredShopOptions().map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              )}
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Tags</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.tagsString || ''}
                      onChange={(e) => {
                        const tagsString = e.target.value;
                        this.setState(prevState => ({
                          createFormData: {
                            ...prevState.createFormData,
                            tagsString: tagsString
                          }
                        }));
                      }}
                      onBlur={(e) => {
                        // Process tags when user finishes typing
                        const tagsString = e.target.value;
                        const tagsArray = tagsString ? 
                          tagsString.split(',').map(tag => tag.trim()).filter(tag => tag) : [];
                        this.handleCreateInputChange('tags', tagsArray);
                      }}
                      placeholder="Nhập tags, phân cách bằng dấu phẩy (ví dụ: tag1, tag2, tag3)"
                    />
                    <Form.Text className="text-muted">
                      Gõ tags và phân cách bằng dấu phẩy. Ví dụ: "hình ảnh, sản phẩm, bán hàng"
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Mô tả</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.createFormData.description}
                      onChange={(e) => this.handleCreateInputChange('description', e.target.value)}
                      placeholder="Nhập mô tả album"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={this.state.createFormData.note}
                      onChange={(e) => this.handleCreateInputChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              {/* Cover Upload Section */}
              <Row className="mb-4">
                <Col>
                  <h6 className="text-primary">Ảnh bìa</h6>
                  <hr />
                  <div className="border rounded p-3">
                    {this.state.createFormData.cover_url ? (
                      <div className="text-center">
                        <img 
                          src={this.state.createFormData.cover_url} 
                          alt="Cover"
                          style={{ 
                            maxWidth: '200px', 
                            maxHeight: '200px', 
                            objectFit: 'cover',
                            borderRadius: '8px',
                            border: '3px solid #dee2e6',
                            marginBottom: '15px'
                          }}
                        />
                        <div className="d-flex gap-2 justify-content-center">
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={this.handleOpenImageUploadModal}
                          >
                            <FaUpload size={12} className="me-1" />
                            Thay đổi ảnh bìa
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => this.handleCreateInputChange('cover_url', '')}
                          >
                            <FaTimes size={12} className="me-1" />
                            Xóa ảnh bìa
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <div className="text-center text-muted py-4">
                        <div 
                          style={{ 
                            width: '200px', 
                            height: '150px', 
                            backgroundColor: '#f8f9fa',
                            borderRadius: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '3px dashed #dee2e6',
                            margin: '0 auto 15px'
                          }}
                        >
                          <FaImage size={40} color="#6c757d" />
                        </div>
                        <p className="mb-3">Chưa có ảnh bìa</p>
                        <Button
                          variant="primary"
                          onClick={this.handleOpenImageUploadModal}
                        >
                          <FaUpload size={14} className="me-2" />
                          Upload ảnh bìa
                        </Button>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseCreateModal}>
              Hủy
            </Button>
            <Button variant="success" onClick={this.handleCreateAlbum}>
              <i className="fas fa-plus me-1"></i>
              Tạo Album mới
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
        <Modal show={this.state.showEditModal} onHide={this.handleCloseEditModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Chỉnh sửa Album</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Tên album</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.name}
                      onChange={(e) => this.handleEditInputChange('name', e.target.value)}
                      placeholder="Nhập tên album"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>MID (Không thể chỉnh sửa)</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.mid}
                      disabled
                      className="bg-light"
                    />
                    <Form.Text className="text-muted">
                      MID được tạo tự động và không thể thay đổi
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Loại</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.type}
                      onChange={(e) => this.handleEditInputChange('type', e.target.value)}
                    >
                      <option value="LISTING">Listing</option>
                      <option value="AVATAR">Avatar</option>
                      <option value="C3D">C3D</option>
                      <option value="SCAN_PERSON">Scan Person</option>
                      <option value="BACKGROUND">Background</option>
                      <option value="DECORATING">Decorating</option>
                      <option value="OTHER_PUBLIC">Khác (Công khai)</option>
                      <option value="OTHER_PRIVATE">Khác (Riêng tư)</option>
                      <option value="ONM_SHAPE">ONM Shape</option>
                      <option value="ONM_OBJECT">ONM Object</option>
                      <option value="ONM_IMAGE">ONM Image</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleEditInputChange('status', e.target.value)}
                      disabled={this.state.editFormData.posted_listing_id && this.state.editFormData.posted_listing_id.trim() !== ''}
                      className={this.state.editFormData.posted_listing_id && this.state.editFormData.posted_listing_id.trim() !== '' ? 'bg-light' : ''}
                    >
                      <option value="ACTIVE">Hoạt động</option>
                      <option value="INACTIVE">Không hoạt động</option>
                      <option value="DRAFT">Bản nháp</option>
                      <option value="PUBLISHED">Đã xuất bản</option>
                      <option value="ARCHIVED">Đã lưu trữ</option>
                      <option value="PENDING">Chờ duyệt</option>
                      <option value="REJECTED">Từ chối</option>
                    </Form.Select>
                    {this.state.editFormData.posted_listing_id && this.state.editFormData.posted_listing_id.trim() !== '' && (
                      <Form.Text className="text-muted">
                        <i className="fas fa-info-circle me-1"></i>
                        Trạng thái tự động là "Đã xuất bản" khi có Posted Listing ID
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              
              {this.shouldShowListingFields() && (
                <Row className="mb-3">
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Original Listing ID</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.editFormData.original_listing_id}
                        onChange={(e) => this.handleEditInputChange('original_listing_id', e.target.value)}
                        placeholder="Nhập Original Listing ID"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Posted Listing ID</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.editFormData.posted_listing_id}
                        onChange={(e) => this.handleEditInputChange('posted_listing_id', e.target.value)}
                        placeholder="Nhập Posted Listing ID"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )}
              
              {this.shouldShowShopField() && (
                <Row className="mb-3">
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Shop</Form.Label>
                      <Form.Select
                        value={this.state.editFormData.registered_shop_mid}
                        onChange={(e) => this.handleEditInputChange('registered_shop_mid', e.target.value)}
                      >
                        <option value="">Chọn Shop</option>
                        {this.getRegisteredShopOptions().map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              )}
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Người tạo (Không thể chỉnh sửa)</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.username}
                      disabled
                      className="bg-light"
                    />
                    <Form.Text className="text-muted">
                      Username được tạo tự động và không thể thay đổi
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Tags</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.tagsString || ''}
                      onChange={(e) => {
                        const tagsString = e.target.value;
                        this.setState(prevState => ({
                          editFormData: {
                            ...prevState.editFormData,
                            tagsString: tagsString
                          }
                        }));
                      }}
                      onBlur={(e) => {
                        // Process tags when user finishes typing
                        const tagsString = e.target.value;
                        const tagsArray = tagsString ? 
                          tagsString.split(',').map(tag => tag.trim()).filter(tag => tag) : [];
                        this.handleEditInputChange('tags', tagsArray);
                      }}
                      placeholder="Nhập tags, phân cách bằng dấu phẩy (ví dụ: tag1, tag2, tag3)"
                    />
                    <Form.Text className="text-muted">
                      Gõ tags và phân cách bằng dấu phẩy. Ví dụ: "hình ảnh, sản phẩm, bán hàng"
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Mô tả</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.description}
                      onChange={(e) => this.handleEditInputChange('description', e.target.value)}
                      placeholder="Nhập mô tả album"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={this.state.editFormData.note}
                      onChange={(e) => this.handleEditInputChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              {/* Cover Upload Section */}
              <Row className="mb-4">
                <Col>
                  <h6 className="text-primary">Ảnh bìa</h6>
                  <hr />
                  <div className="border rounded p-3">
                    {this.state.editFormData.cover_url ? (
                      <div className="text-center">
                        <img 
                          src={this.state.editFormData.cover_url} 
                          alt="Cover"
                          style={{ 
                            maxWidth: '200px', 
                            maxHeight: '200px', 
                            objectFit: 'cover',
                            borderRadius: '8px',
                            border: '3px solid #dee2e6',
                            marginBottom: '15px'
                          }}
                        />
                        <div className="d-flex gap-2 justify-content-center">
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={this.handleOpenImageUploadModal}
                          >
                            <FaUpload size={12} className="me-1" />
                            Thay đổi ảnh bìa
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => this.handleEditInputChange('cover_url', '')}
                          >
                            <FaTimes size={12} className="me-1" />
                            Xóa ảnh bìa
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <div className="text-center text-muted py-4">
                        <div 
                          style={{ 
                            width: '200px', 
                            height: '150px', 
                            backgroundColor: '#f8f9fa',
                            borderRadius: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '3px dashed #dee2e6',
                            margin: '0 auto 15px'
                          }}
                        >
                          <FaImage size={40} color="#6c757d" />
                        </div>
                        <p className="mb-3">Chưa có ảnh bìa</p>
                        <Button
                          variant="primary"
                          onClick={this.handleOpenImageUploadModal}
                        >
                          <FaUpload size={14} className="me-2" />
                          Upload ảnh bìa
                        </Button>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEditModal}>
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveEdit}>
              Lưu thay đổi
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Image Upload Modal */}
        <ImageUploadModal
          show={this.state.showImageUploadModal}
          onHide={this.handleCloseImageUploadModal}
          onImagesUploaded={this.handleImagesUploaded}
          onUploadProgress={this.handleUploadProgress}
          onUploadStart={this.handleUploadStart}
          title="Upload Ảnh bìa"
          maxImages={1}
          existingImages={this.state.uploadedImages}
          uploadProgress={this.state.uploadProgress}
          uploading={this.state.uploadingImages}
        />

        {/* Note Modal */}
        <Modal show={this.state.showNoteModal} onHide={this.handleCloseNoteModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Ghi chú chi tiết</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedNoteData && (
              <div>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>MID:</strong> 
                    <div className="mt-1">
                      <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedNoteData.mid}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Tên album:</strong> 
                    <div className="mt-1">
                      <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedNoteData.name}
                      </Badge>
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Ghi chú:</strong> 
                    <div className="mt-2 p-3 bg-light rounded" style={{ 
                      whiteSpace: 'pre-wrap',
                      maxHeight: '400px',
                      overflowY: 'auto',
                      border: '1px solid #dee2e6'
                    }}>
                      {this.state.selectedNoteData.note || 'Không có ghi chú'}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseNoteModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Iframe Modal */}
        <IframeModal
          show={this.state.showIframeModal}
          onHide={this.handleCloseIframeModal}
          url={this.state.selectedAlbum ? `/admin/tkt1-media/album-detail/${this.state.selectedAlbum.mid}` : ''}
          title={this.state.selectedAlbum ? `Album ${this.state.selectedAlbum.mid} - ${this.state.selectedAlbum.name}` : 'Album'}
          showSidebar={false}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    albums: state.tkt1ImageAlbumReducer.albums,
    totalCount: state.tkt1ImageAlbumReducer.totalCount,
    registeredEtsyShops: state.tkt1RegisteredEtsyShopReducer?.registeredEtsyShops || []
  };
};

export default connect(mapStateToProps, { getTKT1ImageAlbums, createTKT1ImageAlbum, updateTKT1ImageAlbum, deleteTKT1ImageAlbum, getTKT1RegisteredEtsyShops })(TKT1ImageAlbum);
